import { Injectable, inject } from '@angular/core';
import { Banner } from 'src/models/banner.model';
import { BaseService } from '../base.service';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BannerService extends BaseService {
    protected store = inject<Store<{ config: ConfigState }>>(Store);
    private http = inject(HttpClient);
    public constructor() {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async get(): Promise<Banner> {
        return firstValueFrom(
            this.http.get<Banner>('/api/banner/1', {
                headers: await this.createHeaders(),
            })
        );
    }

    public async set(banner: Banner): Promise<Banner> {
        return firstValueFrom(
            this.http.put<Banner>('/api/banner', banner, {
                headers: await this.createHeaders(),
            })
        );
    }
}
